import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Users, Package, PlusCircle, CreditCard, ShieldCheck } from 'lucide-react';

function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(location.pathname);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    const menuItems = [
        { 
            path: "/admin/dashboard", 
            icon: Home, 
            label: "Dashboard" 
        },
        { 
            path: "/admin/dashboard/users", 
            icon: Users, 
            label: "Users" 
        },
        { 
            path: "/admin/dashboard/products", 
            icon: Package, 
            label: "Products" 
        },
        { 
            path: "/admin/dashboard/addnewproducts", 
            icon: PlusCircle, 
            label: "Admins" 
        },
        { 
            path: "/admin/dashboard/PayementProof", 
            icon: CreditCard,
            label: "Proof Payment"
        }
    ];

    const handleLogout = () => {
        setIsLoggingOut(true);
        
        // Simulate API call or any async operation
        setTimeout(() => {
            // Remove admin details from localStorage
            localStorage.removeItem('authUser');
            
            // Redirect to login page
            navigate('/admin/auth/login');
            
            // Reset loading state (though we're navigating away)
            setIsLoggingOut(false);
        }, 1000); // 1 second delay to show loading state
    };

    return (
        <div className="bg-gray-50 w-64 h-screen fixed left-0 top-0 shadow-lg">
            <div className="p-6 border-b border-gray-200 flex items-center space-x-3">
                <ShieldCheck className="w-10 h-10 text-blue-600" />
                <h2 className="text-xl font-bold text-gray-800">Admin Panel</h2>
            </div>

            <nav className="p-4">
                {menuItems.map((item) => (
                    <Link 
                        key={item.path}
                        to={item.path} 
                        className={`
                            flex items-center p-3 rounded-lg mb-2 transition-all duration-200
                            ${location.pathname === item.path 
                                ? 'bg-blue-100 text-blue-600 font-semibold' 
                                : 'text-gray-600 hover:bg-gray-100'}
                        `}
                        onClick={() => setActiveTab(item.path)}
                    >
                        <item.icon 
                            className={`mr-3 w-5 h-5 
                                ${location.pathname === item.path 
                                    ? 'text-blue-600' 
                                    : 'text-gray-500'}
                            `} 
                        />
                        {item.label}
                    </Link>
                ))}
            </nav>

            <div className="absolute bottom-0 w-full p-4 border-t border-gray-200">
                <button 
                    onClick={handleLogout}
                    disabled={isLoggingOut}
                    className="w-full bg-red-50 text-red-600 py-2 rounded-lg 
                    flex items-center justify-center hover:bg-red-100 transition-colors
                    disabled:opacity-70 disabled:cursor-not-allowed"
                >
                    {isLoggingOut ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Logging out...
                        </>
                    ) : (
                        <>
                            <ShieldCheck className="mr-2 w-5 h-5" />
                            Logout
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}

export default Sidebar;